import {
  Box,
  Button,
  Chip,
  Paper,
  Typography,
  styled,
} from '@material-ui/core';

export const DashboardLayout = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(3),
  gridTemplateColumns: '1fr 1fr',
  width: '100%',
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: '1fr',
  },
}));

export const ColumnCard = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 12,
  boxShadow: 'none',
  overflow: 'hidden',
}));

export const ColumnHeader = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.spacing(1.5),
  padding: theme.spacing(2.5, 3),
}));

export const ColumnIconWrap = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.background.default,
  borderRadius: '12px',
  color: theme.palette.primary.main,
  display: 'flex',
  flexShrink: 0,
  height: 52,
  justifyContent: 'center',
  width: 52,
}));

export const ColumnTitle = styled(Typography)({
  fontSize: 16,
  fontWeight: 700,
  lineHeight: '24px',
});

export const ColumnSubtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: 13,
  lineHeight: '20px',
}));

export const EmptyColumnMessage = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: 13,
  lineHeight: '20px',
  padding: theme.spacing(2, 3, 3),
}));

export const ApplicationBlock = styled(Box)({});

export const ApplicationHeader = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  borderBottom: `1px solid ${theme.palette.divider}`,
  borderTop: `1px solid ${theme.palette.divider}`,
  color: theme.palette.text.secondary,
  display: 'flex',
  gap: theme.spacing(1),
  padding: theme.spacing(1.5, 3),
}));

export const ApplicationName = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: 12,
  fontWeight: 700,
  letterSpacing: 0.4,
  textTransform: 'uppercase',
}));

export const RoleRow = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1.5, 0, 2),
}));

export const RoleHeader = styled(Box)(({ theme }) => ({
  alignItems: 'flex-start',
  display: 'flex',
  gap: 8,
  padding: theme.spacing(0, 3),
  '&.expanded': {
    borderBottom: `1px solid ${theme.palette.divider}`,
    marginBottom: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
  },
}));

export const ExpandButton = styled('button')(({ theme }) => ({
  alignItems: 'center',
  background: 'none',
  border: 'none',
  color: theme.palette.text.secondary,
  cursor: 'pointer',
  display: 'flex',
  flexShrink: 0,
  height: 24,
  justifyContent: 'center',
  marginTop: 2,
  padding: 0,
  width: 24,
}));

export const RoleCopy = styled(Box)({
  flex: 1,
  minWidth: 0,
});

export const RoleName = styled(Typography)({
  fontSize: 16,
  fontWeight: 700,
  lineHeight: '24px',
});

export const RoleDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: 13,
  lineHeight: '20px',
  marginTop: 2,
}));

export const GrantedChip = styled(Chip)(({ theme }) => ({
  backgroundColor: `${theme.palette.success.main} !important`,
  color: `${theme.palette.common.white} !important`,
  padding: '0 8px',
  '& .MuiChip-icon': {
    color: theme.palette.common.white,
    fontSize: 14,
  },
}));

export const RequestAccessButton = styled(Button)({
  borderRadius: 20,
  flexShrink: 0,
  fontSize: 12,
  fontWeight: 700,
  padding: '6px 14px',
  whiteSpace: 'nowrap',
  '& .MuiButton-startIcon': {
    marginLeft: -4,
    marginRight: 4,
  },
  '& .MuiButton-startIcon > *:first-child': {
    fontSize: 16,
  },
});

export const RoleDetails = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
  padding: theme.spacing(0, 3, 0, 7),
}));

export const DetailSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

export const DetailHeading = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  color: theme.palette.text.secondary,
  display: 'flex',
  fontSize: 11,
  fontWeight: 700,
  gap: theme.spacing(1),
  letterSpacing: 0.6,
  textTransform: 'uppercase',
}));

export const ChipRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
}));

export const PermissionChip = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.lightBlue,
  color: theme.palette.primary.main,
}));
